export const ListQueryKey = 'welfare-projects';
export const DetailQueryKey = 'welfare-project';

export const Urls = {
  selectUrl: '/welfareProject/list',
  updateUrl: '/welfareProject/update',
  deleteUrl: '/welfareProject/delete',
  createUrl: '/welfareProject/create',
  detailUrl: '/welfareProject/detail',
};
